<!-- ---------------------------------------------------------------- cabecera -->
<div class="z-page-head z-rise">
  <div>
    <h1 class="z-page-title">Acciones</h1>
    <p class="z-page-subtitle">
      Qué hacemos: las alertas de detractores que hay que cerrar y los planes de
      acción comprometidos por cada sucursal.
    </p>
  </div>

  <div class="z-page-actions">
    <button class="z-btn z-btn--glass" type="button" (click)="descargar()">
      <i class="bi bi-download" aria-hidden="true"></i> Descargar CSV
    </button>
  </div>
</div>

<app-filter-bar [fields]="filtros"
                [selected]="seleccion"
                (selectedChange)="onFiltros($event)" />

<app-section-tabs [tabs]="tabs" [active]="tab" (activeChange)="onTab($event)" />

@switch (tab) {

  <!-- ------------------------------------------------------------- alertas -->
  @case ('alertas') {
    <div class="acc-tab" role="tabpanel" aria-labelledby="z-tab-alertas">

      <div class="z-kpi-grid">
        @for (kpi of kpis; track kpi.label) {
          <app-stat-card class="z-rise"
                         [ngClass]="'z-rise-' + ($index + 1)"
                         [label]="kpi.label"
                         [value]="kpi.value"
                         [color]="colorKpi(kpi)"
                         [icon]="iconoKpi(kpi)" />
        }
      </div>

      <section class="z-panel z-rise z-rise-5">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Histórico de detractores</h2>
            <p class="z-panel-hint">Detractores recibidos mes a mes en los últimos 13 meses.</p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-chart [options]="historico" [height]="300" />
        </div>
      </section>

      <section class="z-panel acc-alerts z-rise z-rise-6">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Alertas pendientes por atender</h2>
            <p class="z-panel-hint">
              El icono de la columna DETALLE abre el comentario completo del cliente.
            </p>
          </div>

          <div class="z-panel-actions">
            <span class="z-scroll-hint">
              <i class="bi bi-arrow-left-right" aria-hidden="true"></i>
              La tabla se desplaza en horizontal
            </span>
          </div>
        </header>

        <div class="z-panel-body">
          <!-- La clase va en el host y no en la tabla: app-data-table es compartida
               y no expone un input para la clase del <table>; la regla global pega
               la primera celda de cualquier fila descendiente. -->
          <app-data-table class="z-table--sticky-first"
                          [columns]="columnasPendientes"
                          exportTitle="Alertas pendientes por atender"
                          [exportFilters]="filtrosTexto"
                          [rows]="alertasPendientes"
                          [exportButtons]="exportacion"
                          [showLengthSelect]="true"
                          [showInfo]="true"
                          [pageSize]="10"
                          (iconAction)="onDetalle($event)" />
        </div>
      </section>

      <section class="z-panel acc-alerts z-rise z-rise-7">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Alertas atendidas</h2>
            <p class="z-panel-hint">Casos cerrados con la gestión que se hizo con el cliente.</p>
          </div>

          <div class="z-panel-actions">
            <span class="z-scroll-hint">
              <i class="bi bi-arrow-left-right" aria-hidden="true"></i>
              La tabla se desplaza en horizontal
            </span>
          </div>
        </header>

        <div class="z-panel-body">
          <app-data-table class="z-table--sticky-first"
                          [columns]="columnasAtendidas"
                          exportTitle="Alertas atendidas"
                          [exportFilters]="filtrosTexto"
                          [rows]="alertasAtendidas"
                          [exportButtons]="exportacion"
                          [showLengthSelect]="true"
                          [showInfo]="true"
                          [pageSize]="10"
                          (iconAction)="onDetalle($event)" />
        </div>
      </section>

    </div>
  }

  <!-- -------------------------------------------------------------- planes -->
  @case ('planes') {
    <div class="acc-tab" role="tabpanel" aria-labelledby="z-tab-planes">

      <section class="z-panel acc-plans z-rise z-rise-1">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Revisión de planes de acción</h2>
            <p class="z-panel-hint">
              Comentario que originó el caso, fecha de compromiso y plan capturado.
            </p>
          </div>

          <div class="z-panel-actions">
            <span class="z-scroll-hint">
              <i class="bi bi-arrow-left-right" aria-hidden="true"></i>
              La tabla se desplaza en horizontal
            </span>
          </div>
        </header>

        <div class="z-panel-body">
          <app-data-table class="z-table--sticky-first"
                          [columns]="columnasPlanes"
                          exportTitle="Revisión de planes de acción"
                          [exportFilters]="filtrosTexto"
                          [rows]="planes"
                          [exportButtons]="exportacion"
                          [showInfo]="true"
                          [pageSize]="10" />
        </div>
      </section>

    </div>
  }
}

<!-- ------------------------------------------------------- modal de detalle -->
@if (detalle) {
  <app-modal title="Detalle de la alerta" [wide]="true" (closed)="cerrarDetalle()">
    <div class="acc-detalle">

      <div class="acc-detalle-meta">
        <div class="acc-detalle-item">
          <span class="acc-detalle-label">Sucursal</span>
          <span class="acc-detalle-valor">{{ detalle.sucursal }}</span>
        </div>
        <div class="acc-detalle-item">
          <span class="acc-detalle-label">Región</span>
          <span class="acc-detalle-valor">{{ detalle.region }}</span>
        </div>
        <div class="acc-detalle-item">
          <span class="acc-detalle-label">Zona</span>
          <span class="acc-detalle-valor">{{ detalle.zona }}</span>
        </div>
        <div class="acc-detalle-item">
          <span class="acc-detalle-label">Estado</span>
          <span class="acc-detalle-valor">{{ detalle.estado }}</span>
        </div>
        <div class="acc-detalle-item">
          <span class="acc-detalle-label">Recomendación</span>
          <span class="acc-detalle-valor">{{ detalle.recomendacion }}</span>
        </div>
        <div class="acc-detalle-item">
          <span class="acc-detalle-label">Categoría</span>
          <span class="acc-detalle-valor">{{ detalle.categoria }}</span>
        </div>
      </div>

      <p class="acc-detalle-titulo">Comentario del cliente</p>
      <blockquote class="acc-detalle-comentario">{{ detalle.comentario }}</blockquote>

    </div>
  </app-modal>
}
